export const tenantLogsMessages = (item) => {
    return {
        "tenant-logs-invalid-date-filter": "Invalid Start Date or End Date",
        "tenant-logs-start-date-greater-than-end-date": "Start Date cannnot be greater than End Date",
        "tenant-logs-api-failure": "Failed to get the Tenant Logs data",
        "tenant-logs-no-data-found": "No data found for selected filters."
    }
}